import { render, staticRenderFns } from "./NoLandscape.vue?vue&type=template&id=16460fa4&scoped=true"
import script from "./NoLandscape.vue?vue&type=script&lang=js"
export * from "./NoLandscape.vue?vue&type=script&lang=js"
import style0 from "./NoLandscape.vue?vue&type=style&index=0&id=16460fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16460fa4",
  null
  
)

export default component.exports